import { ApiService } from '../common/serviceBase';
import { URL_REPORTS } from '../common/apiUrl';

export class RelmodelosService {
    constructor() {
        this.service = new ApiService(`${URL_REPORTS}/relatorios/relmodelos`);
    }

    async getAll(rela_id) {
        const response = await this.service.get(`${rela_id}/all`);
        return response.data;
    }

    async create(data) {
        const response = await this.service.post('', data);
        return response.data;
    }

    async update(relm_id, data) {
        const response = await this.service.put(relm_id, data);
        return response.data;
    }

    async remove(relm_id) {
        const response = await this.service.delete(relm_id);
        return response;
    }

    async get(rela_id) {
        const response = await this.service.get(rela_id);
        return response.data;
    }
}